<template>
  <card-dialog
    v-model="modalVisible"
    fullscreen
    persistent
    prevent-close
    @close="anyProgressMade ? closeConfirmationDialogVisible = true : modalVisible = false"
  >
    <template v-slot:title>
      <v-card-title class="grey-bg px-6 py-3">
        <div v-if="questionnaireFormData.id">
          {{ $t("card_dialog.edit_questionnaire.title", { name: $t(`questionnaire_name.${ questionnaireFormData.name.toLowerCase().replace(/-/g, "").replace(/\s+/g, "_")}`) }) }}
          <!--          {{ $t(`questionnaire_name.${questionnaire.name.toLowerCase().replace(/-/g, "").replace(/\s+/g, "_")}`) }}-->
        </div>
        <div v-else>
          {{ $t('card_dialog.new_questionnaire.title') }}
        </div>
      </v-card-title>
    </template>
    <v-card-text class="pa-0">
      <validation-observer ref="validation">
        <v-row
          class="fill-height"
          no-gutters
        >
          <v-col
            cols="4"
            class="fill-height overflow-auto pa-6"
          >
            <div class="subtitle-1 font-weight-bold mb-4">
              {{ $t(`questionnaire_name.${ questionnaireFormData.name.toLowerCase().replace(/-/g, "").replace(/\s+/g, "_")}`) }}
            </div>
            <validation-provider
              v-slot="{ errors }"
              rules="required"
            >
              <v-textarea
                v-model="questionnaireFormData.description"
                :error-messages="errors"
                :label="$t('text_input.description.title')"
                outlined
                :rows="3"
                :placeholder="$t('text_input.description.placeholder')"
              />
            </validation-provider>
            <v-switch
              v-model="questionnaireFormData.is_active"
              :label="questionnaireFormData.is_active ? $t('admin.status.active') : $t('admin.status.inactive')"
              :disabled="questionnaireFormData.questions.every(q => !q.is_active)"
              class="ma-0 pa-0"
            />

            <div
              v-if="questionnaireFormData.is_active"
              class="mt-4"
            >
              <v-card
                v-for="team in teams"
                :key="team.id"
                outlined
                class="mb-3"
              >
                <v-card-title class="grey-bg subtitle-1 font-weight-bold px-6 py-3">
                  <v-row
                    no-gutters
                    align="center"
                  >
                    <v-col>
                      {{ team.name }}
                    </v-col>
                    <v-col cols="auto">
                      <v-switch
                        v-model="team.is_active"
                        hide-details
                        class="py-0 my-0"
                        :label="$t('table_headers.active')"
                      />
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text
                  v-if="team.is_active"
                  class="pa-0 v-list--bordered"
                >
                  <v-row
                    v-for="coach in team.coaches"
                    :key="team.id + coach.id"
                    no-gutters
                    class="py-1 px-6 text-body-1 v-list-item"
                  >
                    <v-col>
                      {{ coach.first_name }} {{ coach.last_name }}
                    </v-col>
                    <v-col
                      cols="auto"
                      class="pr-5"
                    >
                      <v-switch
                        v-model="coach.can_view"
                        :label="$t('switch.can_view')"
                        hide-details
                        class="pa-0 ma-0"
                      />
                    </v-col>
                    <v-col cols="auto">
                      <v-switch
                        v-model="coach.can_edit"
                        :label="$t('switch.can_enter_results')"
                        hide-details
                        class="pa-0 ma-0"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </div>
          </v-col>

          <v-divider vertical />

          <v-col class="fill-height pa-6 pb-0">
            <div class="d-flex flex-column no-gutters fill-height">
              <div class="col pa-0">
                <v-row
                  no-gutters
                  justify="center"
                >
                  <v-col xl="8">
                    <v-row
                      no-gutters
                      align="center"
                    >
                      <v-col>
                        <subtitle>
                          {{ $t('questionnaires.questions.title') }}
                        </subtitle>
                      </v-col>
                      <v-col cols="auto">
                      <!--                    <v-btn-->
                      <!--                      color="primary"-->
                      <!--                      small-->
                      <!--                      @click="addNewQuestion"-->
                      <!--                    >-->
                      <!--                      {{ $t("button.add") }}-->
                      <!--                      <v-icon-->
                      <!--                        right-->
                      <!--                        small-->
                      <!--                      >-->
                      <!--                        far fa-plus-->
                      <!--                      </v-icon>-->
                      <!--                    </v-btn>-->
                      </v-col>
                    </v-row>

                    <div class="mt-8">
                      <draggable
                        v-model="questionnaireFormData.questions"
                        handle=".handle"
                        :group="{ name: 'questions' }"
                        :invert-swap="true"
                        :swap-threshold="0.6"
                        :animation="100"
                        @change="anyProgressMade = true"
                      >
                        <div
                          v-for="(question, index) in questionnaireFormData.questions"
                          :key="index"
                        >
                          <div v-if="question.type === 'group'">
                            <v-card
                              outlined
                              rounded="lg"
                              class="mb-3"
                            >
                              <v-card-title class="subtitle-1 font-weight-bold px-6 py-6">
                                <v-row no-gutters>
                                  <!--                                  <v-col cols="auto">-->
                                  <!--                                    <v-icon-->
                                  <!--                                      small-->
                                  <!--                                      class="handle mr-2"-->
                                  <!--                                      style="cursor: move"-->
                                  <!--                                    >-->
                                  <!--                                      far fa-grip-lines-->
                                  <!--                                    </v-icon>-->
                                  <!--                                  </v-col>-->
                                  <v-col>
                                    {{ $t(`questionnaire_question.${question.text.toLowerCase().replace(/[\s\-()]+/g, "_")}`) }}
                                  </v-col>
                                </v-row>
                              </v-card-title>
                              <v-card-text>
                                <draggable
                                  v-model="question.questions"
                                  handle=".subhandle"
                                  :group="{ name: 'group' }"
                                  :invert-swap="true"
                                  :swap-threshold="0.6"
                                  :animation="100"
                                  @change="anyProgressMade = true"
                                >
                                  <div
                                    v-for="(subQuestion, subIndex) in question.questions"
                                    :key="index + subIndex"
                                  >
                                    <v-card
                                      v-if="!subQuestion.is_hidden"
                                      class="mb-3"
                                      rounded="lg"
                                      elevation="10"
                                      outlined
                                    >
                                      <v-card-text class="py-4 px-6">
                                        <v-row
                                          align="center"
                                          no-gutters
                                        >
                                          <!--                                          <v-col cols="auto">-->
                                          <!--                                            <v-icon-->
                                          <!--                                              small-->
                                          <!--                                              class="subhandle mr-2"-->
                                          <!--                                              style="cursor: move"-->
                                          <!--                                            >-->
                                          <!--                                              far fa-grip-lines-->
                                          <!--                                            </v-icon>-->
                                          <!--                                          </v-col>-->
                                          <v-col class="px-6">
                                            {{ $t(`questionnaire_question.${subQuestion.text.toLowerCase().replace(/[\s\-()]+/g, "_")}`) }}
                                          </v-col>
                                          <v-col
                                            cols="auto"
                                            class="pr-6"
                                          >
                                            <v-tooltip top>
                                              <template v-slot:activator="{ on }">
                                                <v-chip
                                                  label
                                                  outlined
                                                  v-on="subQuestion.settings.items ? on : undefined"
                                                >
                                                  <div v-if="subQuestion.type === 'grade'">
                                                    {{ $t('questionnaire_question.type.grade') }}: {{ subQuestion.settings.min }} - {{ subQuestion.settings.max }}
                                                  </div>
                                                  <div v-else-if="subQuestion.type === 'number'">
                                                    {{ $t('questionnaire_question.type.number') }}: {{ subQuestion.settings.min }} - {{ subQuestion.settings.max }}
                                                  </div>
                                                  <div v-else-if="subQuestion.type === 'select'">
                                                    {{ $t('questionnaire_question.type.select') }}
                                                    <v-icon
                                                      right
                                                      x-small
                                                    >
                                                      far fa-circle-info
                                                    </v-icon>
                                                  </div>
                                                  <div v-else-if="subQuestion.type === 'multiselect'">
                                                    {{ $t('questionnaire_question.type.multi_select') }}
                                                    <v-icon
                                                      right
                                                      x-small
                                                    >
                                                      far fa-circle-info
                                                    </v-icon>
                                                  </div>
                                                  <div v-else-if="subQuestion.type === 'pain_avatar'">
                                                    {{ $t('questionnaire_question.type.pain_avatar') }}
                                                  </div>
                                                  <div v-else-if="subQuestion.type === 'boolean'">
                                                    {{ $t('status.yes') }} / {{ $t('status.yes') }}
                                                  </div>
                                                </v-chip>
                                              </template>
                                              <div v-if="subQuestion.settings.items && subQuestion.settings.items.length > 0">
                                                <div
                                                  v-for="item in subQuestion.settings.items"
                                                  :key="question.id + subQuestion.id + item.value"
                                                >
                                                  {{ item.text }}
                                                </div>
                                              </div>
                                            </v-tooltip>
                                          </v-col>
                                          <v-col
                                            cols="auto"
                                            style="min-width: 130px"
                                          >
                                            <v-switch
                                              v-model="subQuestion.is_active"
                                              :label="subQuestion.is_active ? $t('admin.status.active') : $t('admin.status.inactive')"
                                              :color="subQuestion.is_active ? 'success' : 'grey'"
                                              dense
                                              @change="questionToggled"
                                            />
                                          </v-col>
                                        </v-row>
                                      </v-card-text>
                                    </v-card>
                                  </div>
                                </draggable>
                              </v-card-text>
                            </v-card>
                          </div>
                          <!--                          <v-hover v-slot="{hover}">-->
                          <v-card
                            v-else-if="!question.is_hidden"
                            class="mb-3"
                            rounded="lg"
                            elevation="10"
                            outlined
                          >
                            <v-card-text class="py-4 px-6">
                              <v-row
                                align="center"
                                no-gutters
                              >
                                <!--                                <v-col cols="auto">-->
                                <!--                                  <v-icon-->
                                <!--                                    small-->
                                <!--                                    class="handle mr-2"-->
                                <!--                                    style="cursor: move"-->
                                <!--                                  >-->
                                <!--                                    far fa-grip-lines-->
                                <!--                                  </v-icon>-->
                                <!--                                </v-col>-->
                                <v-col class="px-6">
                                  {{ $t(`questionnaire_question.${question.text.toLowerCase().replace(/[\s\-()]+/g, "_")}`) }}
                                  <!--                                  <validation-provider-->
                                  <!--                                    v-slot="{ errors }"-->
                                  <!--                                    rules="required"-->
                                  <!--                                  >-->
                                  <!--                                    <v-text-field-->
                                  <!--                                      v-model="question.text"-->
                                  <!--                                      :error-messages="errors"-->
                                  <!--                                      :label="$t('text_input.question_text.title')"-->
                                  <!--                                      outlined-->
                                  <!--                                      dense-->
                                  <!--                                      hide-details-->
                                  <!--                                    />-->
                                  <!--                                  </validation-provider>-->
                                </v-col>
                                <v-col
                                  cols="auto"
                                  class="pr-6"
                                >
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                      <v-chip
                                        label
                                        outlined
                                        v-on="question.settings.items ? on : undefined"
                                      >
                                        <div v-if="question.type === 'grade'">
                                          {{ $t(`questionnaire_question.type.${question.type}`) }}: {{ question.settings.min }} - {{ question.settings.max }}
                                        </div>
                                        <div v-else-if="question.type === 'number'">
                                          {{ $t(`questionnaire_question.type.${question.type}`) }}: {{ question.settings.min }} - {{ question.settings.max }}
                                        </div>
                                        <div v-else-if="question.type === 'select'">
                                          {{ $t(`questionnaire_question.type.${question.type}`) }}
                                          <v-icon
                                            x-small
                                          >
                                            far fa-circle-info
                                          </v-icon>
                                        </div>
                                        <div v-else-if="question.type === 'multiselect'">
                                          {{ $t(`questionnaire_question.type.${question.type}`) }}
                                          <v-icon
                                            x-small
                                          >
                                            far fa-circle-info
                                          </v-icon>
                                        </div>
                                        <div v-else-if="question.type === 'pain_avatar'">
                                          {{ $t(`questionnaire_question.type.${question.type}`) }}
                                        </div>
                                        <div v-else-if="question.type === 'boolean'">
                                          {{ $t('status.yes') }} / {{ $t('status.yes') }}
                                        </div>
                                      </v-chip>
                                    </template>
                                    <div v-if="question.settings.items && question.settings.items.length > 0">
                                      <div
                                        v-for="item in question.settings.items"
                                        :key="question.id + item.value"
                                      >
                                        {{ item.text }}
                                      </div>
                                    </div>
                                  </v-tooltip>
                                </v-col>
                                <v-col
                                  cols="auto"
                                  style="min-width: 130px"
                                >
                                  <v-switch
                                    v-model="question.is_active"
                                    :label="question.is_active ? $t('admin.status.active') : $t('admin.status.inactive')"
                                    :color="question.is_active ? 'success' : 'grey'"
                                    dense
                                    @change="questionToggled"
                                  />
                                </v-col>
                              </v-row>

                              <!--                                <v-row-->
                              <!--                                  align="center"-->
                              <!--                                  class="mt-1"-->
                              <!--                                >-->
                              <!--                                  <v-col cols="auto">-->
                              <!--                                    <v-btn-->
                              <!--                                      :style="{ opacity: hover ? 1 : 0.2, transition: 'opacity 0.3s' }"-->
                              <!--                                      icon-->
                              <!--                                      small-->
                              <!--                                      @click="removeQuestion(index)"-->
                              <!--                                    >-->
                              <!--                                      <v-icon-->
                              <!--                                        x-small-->
                              <!--                                        color="error"-->
                              <!--                                      >-->
                              <!--                                        far fa-trash-alt-->
                              <!--                                      </v-icon>-->
                              <!--                                    </v-btn>-->
                              <!--                                  </v-col>-->
                              <!--                                </v-row>-->
                            </v-card-text>
                          </v-card>
                          <!--                          </v-hover>-->
                        </div>
                      </draggable>

                      <v-card
                        v-if="questionnaireFormData.questions.length === 0"
                        color="grey lighten-4"
                        rounded="lg"
                        flat
                      >
                        <v-card-text class="text-center py-6 grey--text">
                          <div class="mb-4">
                            <v-icon
                              large
                              color="grey lighten-1"
                            >
                              fal fa-circle-plus
                            </v-icon>
                          </div>
                          <div>{{ $t('questionnaires.no_questions.placeholder') }}</div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-col>
        </v-row>
      </validation-observer>
    </v-card-text>
    <template v-slot:actions>
      <v-card-actions class="pa-4">
        <v-btn
          color="primary"
          large
          :loading="submitting"
          @click="submit()"
        >
          {{ $t('button.save') }}
        </v-btn>
        <v-btn
          color="grey"
          text
          @click="modalVisible = false"
        >
          {{ $t('button.cancel') }}
        </v-btn>
        <v-spacer />
        <!--        <v-btn-->
        <!--          v-if="questionnaireFormData.id"-->
        <!--          color="error"-->
        <!--          text-->
        <!--          @click="deleteConfirmationDialogVisible = true"-->
        <!--        >-->
        <!--          {{ $t('button.delete') }}-->
        <!--        </v-btn>-->
      </v-card-actions>
    </template>

    <delete-confirmation-dialog
      :visible.sync="deleteConfirmationDialogVisible"
      :submitting="deleting"
      @confirmed="deleteQuestionnaire()"
    />

    <delete-confirmation-dialog
      :visible.sync="closeConfirmationDialogVisible"
      :title="$t('card_dialog.lose_progress.title')"
      :text="$t('card_dialog.lose_progress.label')"
      :cta-text="$t('card_dialog.lose_progress.button')"
      @confirmed="modalVisible = false"
    />
  </card-dialog>
</template>

<script>
import CardDialog from '@/components/helpers/CardDialog'
import deleteConfirmationMixin from '@/mixins/deleteConfirmationMixin'
import { EventBus } from '@/plugins/bus'
import DeleteConfirmationDialog from '@/components/dialogs/DeleteConfirmationDialog'
import Subtitle from '@/components/helpers/Subtitle'
import { cloneDeep } from 'lodash'
import draggable from 'vuedraggable'
import { QuestionnaireApiService } from '@/data/services/QuestionnaireApiService'

const emptyQuestionnaireFormData = {
  id: undefined,
  name: '',
  description: '',
  type: '',
  is_active: true,
  is_on_demand: false,
  settings: {},
  trigger_criteria: {},
  questions: [],
  teams: [],
  coach_permissions: []
}

// Define empty question structure
const emptyQuestion = {
  id: undefined,
  text: '',
  is_active: true,
  order: 0
}

export default {
  name: 'QuestionnaireFormDialog',
  components: { draggable, Subtitle, DeleteConfirmationDialog, CardDialog },
  mixins: [deleteConfirmationMixin],
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      questionnaireFormData: cloneDeep(emptyQuestionnaireFormData),
      teams: [],
      submitting: false,
      anyProgressMade: false,
      deleteConfirmationDialogVisible: false,
      closeConfirmationDialogVisible: false
    }
  },
  computed: {
    modalVisible: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        this.$emit('update:visible', value)
      }
    },
    allTeams() {
      return this.$store.getters[this.$storeGetters.APP_TEAMS]
    }
  },
  watch: {
    visible(newValue) {
      if (!newValue) return

      // Reset the form when dialog is opened
      setTimeout(() => {
        this.$refs.validation.reset()
      }, 0)

      this.$nextTick(() => {
        this.anyProgressMade = false
      })
    },
    questionnaireFormData: {
      deep: true,
      handler() {
        this.anyProgressMade = true
      }
    }
  },
  mounted() {
    EventBus.$on(this.$events.EDIT_QUESTIONNAIRE, (questionnaire) => {
      this.questionnaireFormData = cloneDeep(questionnaire)

      if (!this.questionnaireFormData.questions) {
        this.questionnaireFormData.questions = []
      }

      this.fillTeams()

      this.questionnaireFormData.questions.sort((a, b) => a.order - b.order)

      this.modalVisible = true
    })
  },
  beforeDestroy() {
    EventBus.$off(this.$events.EDIT_QUESTIONNAIRE)
  },
  methods: {
    fillTeams() {
      const allTeams = this.$store.getters[this.$storeGetters.APP_TEAMS]

      this.teams = allTeams.map(team => {
        const questionnaireTeam = this.questionnaireFormData.teams.find(qt => qt.id === team.id)

        return {
          id: team.id,
          name: team.name,
          is_active: questionnaireTeam ? questionnaireTeam.is_active : true,
          coaches: team.coaches.map(coach => {
            const questionnaireTeamCoach = this.questionnaireFormData.coach_permissions.find(qc => qc.coach_id === coach.id && qc.team_id === team.id)

            return {
              id: coach.id,
              first_name: coach.first_name,
              last_name: coach.last_name,
              can_edit: questionnaireTeamCoach ? questionnaireTeamCoach.can_edit : true,
              can_view: questionnaireTeamCoach ? questionnaireTeamCoach.can_view : true
            }
          })
        }
      })
    },

    addNewQuestion() {
      const newQuestion = cloneDeep(emptyQuestion)
      newQuestion.order = this.questionnaireFormData.questions.length + 1
      this.questionnaireFormData.questions.push(newQuestion)
      this.anyProgressMade = true
    },

    removeQuestion(index) {
      this.questionnaireFormData.questions.splice(index, 1)
      this.anyProgressMade = true
    },

    async submit() {
      if (!(await this.$refs.validation.validate())) return

      await this.save()
    },

    async save() {
      try {
        this.submitting = true

        // Update order property for each question based on array index
        this.questionnaireFormData.questions.forEach((question, index) => {
          question.order = index + 1
        })

        const data = {
          name: this.questionnaireFormData.name,
          description: this.questionnaireFormData.description,
          is_active: this.questionnaireFormData.is_active,
          questions: this.questionnaireFormData.questions,
          teams: this.teams.map(team => {
            return {
              id: team.id,
              is_active: team.is_active,
              coach_permissions: team.coaches.map(coach => {
                return {
                  coach_id: coach.id,
                  team_id: team.id,
                  can_view: coach.can_view,
                  can_edit: coach.can_edit
                }
              })
            }
          })
        }

        let result

        if (this.questionnaireFormData.id) {
          result = await QuestionnaireApiService.update(this.questionnaireFormData.id, data)
        } else {
          result = await QuestionnaireApiService.create(data)
        }

        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.questionnaire_save.success'),
          color: 'success'
        })

        this.$emit('refresh', result.data)

        // Emit appropriate event based on whether this was a create or update operation
        if (this.questionnaireFormData.id) {
          EventBus.$emit(this.$events.QUESTIONNAIRE_UPDATED, result.data)
        } else {
          EventBus.$emit(this.$events.QUESTIONNAIRE_CREATED, result.data)
        }

        this.modalVisible = false
      } catch (e) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.questionnaire_save.error'),
          color: 'error'
        })
        throw e
      } finally {
        this.submitting = false
      }
    },

    async deleteQuestionnaire() {
      if (!this.questionnaireFormData.id) return

      try {
        this.deleting = true

        await QuestionnaireApiService.delete(this.questionnaireFormData.id)

        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.questionnaire_delete.success'),
          color: 'success'
        })

        this.deleteConfirmationDialogVisible = false

        EventBus.$emit(this.$events.QUESTIONNAIRE_DELETED, this.questionnaireFormData)
        this.modalVisible = false
      } catch (e) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.questionnaire_delete.error'),
          color: 'error'
        })
        throw e
      } finally {
        this.deleting = false
      }
    },

    questionToggled() {
      if (this.questionnaireFormData.questions.every(q => !q.is_active)) this.questionnaireFormData.is_active = false
    }
  }
}
</script>

<style scoped>
/* Add any specific styles here */
</style>
